/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_Job_PositionsInputs */

const en_total_job_positions = /** @type {(inputs: Total_Job_PositionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Job Positions`)
};

const de_total_job_positions = /** @type {(inputs: Total_Job_PositionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellenangebote insgesamt`)
};

/**
* | output |
* | --- |
* | "Total Job Positions" |
*
* @param {Total_Job_PositionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const total_job_positions = /** @type {((inputs?: Total_Job_PositionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_Job_PositionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_total_job_positions(inputs)
	return en_total_job_positions(inputs)
});